import './App.css';
import React from 'react';
import Header from "./partials/header";
import HeaderBociany from "./partials/HeaderBociany";
import Weather from "./partials/Weather";
import Footer from "./partials/footer";
import { Helmet } from "react-helmet";
import { SITE_URL } from "./config/app";
import Player from "./partials/Player";
import History from "./partials/History";

function App() {
  return (
    <>
        <Helmet>
          <link rel="canonical" href={`${SITE_URL}/`} />
          <meta property="og:url" content={`${SITE_URL}/`} />
        </Helmet>
        <div className="App">
            <main className="">
                <Header/>           
                <div className="bg-[#F8F9FA] py-12 px-4 2xl:px-auto">
                  <div className="max-w-screen-2xl m-auto ">
                      <HeaderBociany/>
                  </div>
                  <div className="grid grid-cols-1 md:grid-cols-8 xl:grid-cols-12 gap-6 max-w-screen-2xl m-auto">
  
                    <div className="col-span-12 xl:col-span-8">
                      <Player/>
                    </div>
                    <div className="col-span-12 xl:col-span-4 grid grid-cols-1 md:grid-cols-2 xl:grid-cols-1 gap-4 xl:gap-2.5 xl:self-start">
                      <Weather/>
                      <History/>
                    </div>
                  </div>
                </div>
            </main>
            <Footer />
        </div>
    </>

  );
}

export default App;
